const getInboxIconDivByStatus = (statusIconPrefix = "queue") => {
  return <div className={`actionIconsSprite ${statusIconPrefix}-icon`} />;
};

export const message = {
  statuses: {
    QUEUED: {
      name: "queued",
      icon: {
        inbox: getInboxIconDivByStatus(),
      },
    },
    SENT: {
      name: "sent",
      icon: {
        inbox: getInboxIconDivByStatus("success"),
      },
    },
    DELIVERED: {
      name: "delivered",
      icon: {
        inbox: getInboxIconDivByStatus("delivered"),
      },
    },
    FAILED: {
      name: "failed",
      icon: {
        inbox: getInboxIconDivByStatus("failure"),
      },
    },
    READ: {
      name: "read",
      icon: {
        inbox: getInboxIconDivByStatus("read"),
      },
    },
  },
};

export const MessageDirection = {
  INBOUND: 1,
  OUTBOUND: 2,
  NONE: 3, // Saved Notes or Contact Assignment
};

export const MessageDirectionLabels = {
  [MessageDirection.INBOUND]: "Inbound",
  [MessageDirection.OUTBOUND]: "Outbound",
  [MessageDirection.NONE]: "None",
};